<template>
    <div class="login">
        <div class="login--content">
            <div v-if="failed > 1" class="login--error-login">
                <p class="login--error-login--text">Vyplňte správné uživatelské jméno</p>
                <span class="login--error-login--icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"><path fill="none" stroke="#fefefe" stroke-miterlimit="20" d="M0 8l8-8"/><path fill="none" stroke="#fefefe" stroke-miterlimit="20" d="M0 0l8 8"/></svg>
                </span>
            </div>
            <img src="images/renova-logo.png" alt="RRENOVA" class="login--logo" width="220">
            <form action="" class="login--form">
                <div class="login--input--wrap">
                    <label for="" class="login--label">{{ $t('loginPage.form.username') }}</label>
                    <input v-model="loginForm.email" type="text" class="login--input" :class="{ 'js-active': loginForm.email !== '' }" :disabled="inputsDisabled" @keydown="inputChange" @keyup.enter.prevent="sendLogin" placeholder="Username">
                </div>
                <div class="login--input--wrap">
                    <label for="" class="login--label">{{ $t('loginPage.form.password') }}</label>
                    <input v-model="loginForm.password" type="password" class="login--input" :class="{ 'js-active': loginForm.password !== '' }" :disabled="inputsDisabled" @keydown="inputChange" @keyup.enter.prevent="sendLogin" placeholder="**********">
                    <span v-if="validationErrors.badUsernameOrPasswordError" class="login--error">{{ $t('loginPage.form.errors.badUsernameOrPasswordError' )}}</span>
                </div>
                <div class="login--button--wrap">
                    <button class="login--button" @click.prevent="sendLogin" :disabled="buttonDisabled">
                        <span class="login--button--text">{{ $t('loginPage.form.login') }}</span>
                    </button>
                    <router-link :to="{ name: 'RequestResetPasswordPage' }" class="login--link">{{ $t('loginPage.form.forgottenPassword') }}</router-link>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { checkUserCredentials } from "../../api/login";

export default {
  name: "LoginPage",
  data: function() {
    return {
        failed: 0,
        buttonDisabled: false,
        inputsDisabled: false,
        validationErrors: {
          badUsernameOrPasswordError: false
        },
        loginForm: {
          email: '',
          password: ''
        }
    }
  },
  methods: {
    sendLogin: async function() {
      this.buttonDisabled = true;
      this.inputsDisabled = true;
      try{
        const response = await checkUserCredentials(this.loginForm.email, this.loginForm.password);

        if(response.data.token){
          this.$store.commit('user/setAuthTokens', 'Bearer ' + response.data.token, response.data.refresh_token);

          await this.$store.dispatch("user/fetchUserInfo");
          if (this.$store.getters["user/isUserLogged"]) {
            this.$router.push({name: 'Dashboard' });
          }else{
            throw new Error('not logged');
          }
        }
      }catch(e){
        console.log(e);
        this.validationErrors.badUsernameOrPasswordError = true;
        this.inputsDisabled = false;
        this.failed++;
      }
    },
    inputChange: function(){
      this.validationErrors.badUsernameOrPasswordError = false;
      this.buttonDisabled = false;
    }
  }
};
</script>

<style scoped lang="less">
    .login {
        display: flex;
        min-height: 100vh;
        padding: 30px 10px;
        overflow: hidden;
        margin-bottom: -40vw;
        &--form {
            box-shadow: 0 3.125rem 3.75rem rgba(0, 0, 0, 0.2);
            border-radius: 0.625rem;
            background: #ffffff;
            padding: 25px 25px 30px;
            position: relative;
        }
        &--logo {
            margin: 0 auto 50px;
            mix-blend-mode: multiply;
            position: relative;
        }
        &--content {
            width: 100%;
            max-width: 400px;
            margin: auto;
            position: relative;
        }
        &--input {
            display: flex;
            min-height: 40px;
            width: 100%;
            padding: 8px 12px;
            border: none;
            border-top: solid 2px transparent;
            border-bottom: solid 2px transparent;
            box-shadow: 0 0.063rem 0.188rem rgba(0, 0, 0, 0.2);
            border-radius: 0.25rem;
            background: #ffffff;
            color: #000000;
            font-size: 0.875rem;
            font-weight: 400;
            transition: all 300ms ease;
            &:focus,
            &.js-active {
                outline: none;
                border-radius: 0.25rem 0.25rem 0 0;
                border-bottom-color: #f9a51b;
            }
            &--wrap {
                position: relative;
                margin: 0 0 16px;
            }
        }
        &--label {
            margin: 0 0 4px;
            color: #707070;
            font-size: 0.75rem;
            font-weight: 400;
            transition: all 300ms ease;
        }
        &--button {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 40px;
            min-width: 120px;
            box-shadow: 0 0.063rem 0.188rem rgba(0, 0, 0, 0.2);
            border-radius: 0.25rem;
            background: #f9a51b;
            border: solid 1px #f9a51b;
            color: #ffffff;
            padding: 8px 10px;
            font-size: 1rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 300ms ease;
            &[disabled] {
                box-shadow: 0 0.063rem 0.25rem rgba(0, 0, 0, 0.12), 0 0.125rem 0.25rem #ebebf5;
                background: #cacad7;
                border-color: #cacad7;
                cursor: not-allowed;
            }
            &--text {

            }
            &--wrap {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 20px 0 0;
            }
        }
        &--link {
            color: #f9a51b;
            font-size: 0.875rem;
            font-weight: 400;
            text-decoration: underline;
            padding: 10px;
            margin-right: -10px;
        }
        &--error-login {
            position: absolute;
            top: -120px;
            left: 0;
            right: 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            min-height: 32px;
            padding: 5px 16px;
            box-shadow: 0 1.25rem 3.125rem rgba(214, 7, 79, 0.4);
            border-radius: 0.25rem;
            background: #f12a59;
            color: #ffffff;
            font-size: 0.75rem;
            font-weight: 400;
            &--text {
                max-width: 200px;
            }
            &--icon {
                padding: 5px;
                margin: -5px;
                cursor: pointer;
            }
        }
        &--error {
            font-size: 1rem;
            font-weight: 400;
            color: #ff0000;
            padding: 15px 0 0;
            display: block;
        }
        @media (max-height: 640px) {
            &--error-login {
                top: 60px;
            }
        }
        @media (max-width: 479px) {
            &--form {
                padding: 15px 15px 20px;
            }
        }
    }
</style>
